import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-siteadmin-facility-scan-station",
	templateUrl: "./siteadmin-facility-scan-station.component.html",
	styleUrls: ["./siteadmin-facility-scan-station.component.css"],
})
export class SiteadminFacilityScanStationComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		if (this.ScanStationDataFromMain != undefined) {
			this.EnableMealAccounting = this.ScanStationDataFromMain.EnableMealAccounting;
			this.EnablePersonalItem = this.ScanStationDataFromMain.EnablePersonalItem;
			this.AwayBarcode = this.ScanStationDataFromMain.AwayBarcode;
			this.AwayPhoto = this.ScanStationDataFromMain.AwayPhoto;
		}
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////
	@Output() NextClick: EventEmitter<any> = new EventEmitter();

	@Input() EditMode: any = false;
	@Input() ScanStationDataFromMain: any;

	//Form Data
	EnableMealAccounting: any = false;
	EnablePersonalItem: any = false;
	AwayBarcode: any = false;
	AwayPhoto: any = false;

	errorMessage: any = "";
	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////

	onNext() {
		let myData: any = {
			EnableMealAccounting: this.EnableMealAccounting,
			EnablePersonalItem: this.EnablePersonalItem,
			AwayBarcode: this.AwayBarcode,
			AwayPhoto: this.AwayPhoto,
		};

		this.NextClick.emit({
			NextPage: 4,
			Data: myData,
		});
	}

	//////////////////////////////////////
}
